import React, { useEffect, useState } from 'react';
import { Calculator, Clock, Mail } from 'lucide-react';
import { supabase } from '../lib/supabaseClient';

export default function Results() {
  const [calculatorImage, setCalculatorImage] = useState<string | null>(null);

  useEffect(() => {
    const loadImage = async () => {
      const { data: { publicUrl } } = supabase.storage
        .from('app-img')
        .getPublicUrl('results/calculator.jpg');
      setCalculatorImage(publicUrl);
    };

    loadImage();
  }, []);

  const scrollToEstimation = () => {
    const element = document.getElementById('estimation-rapide');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Image Section */}
          <div className="lg:w-1/2">
            <div className="relative">
              <div className="bg-white/80 backdrop-blur-xl shadow-[0_8px_32px_rgba(42,67,101,0.15)]
                transform hover:scale-[1.02] transition-all duration-300
                relative overflow-hidden rounded-xl">
                <img
                  src={calculatorImage || "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=1280&q=80"}
                  alt="Calculatrice sur documents immobiliers"
                  className="w-full h-full object-cover rounded-xl"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-gradient-to-br from-[#2A4365] via-[#4A5568] to-[#C4A052] rounded-full p-4 shadow-lg">
                <Calculator className="h-8 w-8 text-white" strokeWidth={2.5} />
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="lg:w-1/2">
            <div className="bg-white/80 backdrop-blur-xl p-8 shadow-[0_8px_32px_rgba(42,67,101,0.15)]
              transform hover:scale-[1.02] transition-all duration-300
              relative overflow-hidden rounded-xl">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Résultat d'évaluation instantané
              </h2>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 mt-1">
                    <Mail className="h-6 w-6 text-[#2A4365]" strokeWidth={2.5} />
                  </div>
                  <p className="text-lg text-gray-700">
                    À l'issue de l'évaluation, vous recevez immédiatement un résultat et nous vous enverrons un rapport d'estimation détaillé par email.
                  </p>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 mt-1">
                    <Calculator className="h-6 w-6 text-[#2A4365]" strokeWidth={2.5} />
                  </div>
                  <p className="text-lg text-gray-700">
                    Si vous souhaitez affiner cette première estimation en tenant compte de critères supplémentaires, nous vous proposons une évaluation gratuite sur place par l'un de nos experts immobiliers locaux.
                  </p>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 mt-1">
                    <Clock className="h-6 w-6 text-[#2A4365]" strokeWidth={2.5} />
                  </div>
                  <p className="text-lg text-gray-700">
                    Pour cela, vous pourrez demander un rendez-vous selon vos disponibilités, après avoir reçu le résultat de votre évaluation en ligne.
                  </p>
                </div>
              </div>

              <div className="mt-8">
                <button
                  onClick={scrollToEstimation}
                  className="inline-flex items-center px-6 py-3 text-base font-medium rounded-xl text-white
                    bg-gradient-to-r from-[#2A4365] via-[#4A5568] to-[#C4A052]
                    hover:from-[#1A3355] hover:via-[#3A4558] hover:to-[#B49042]
                    focus:outline-none focus:ring-2 focus:ring-[#2A4365] focus:ring-offset-2
                    transform transition-all duration-300 hover:scale-105"
                >
                  Démarrer mon estimation
                  <svg 
                    className="ml-2 -mr-1 h-5 w-5" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                    strokeWidth={2.5}
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}